import { getApiClient } from './ApiClient'

export const getProgramPhaseListPromise = params => {
  return getApiClient()
    .get('program-phases', { params })
    .then(resp => resp.data)
}

export const getProgramPhaseDetailPromise = id => {
  return getApiClient()
    .get(`program-phases/${id}`)
    .then(resp => resp.data)
}

export const upsertProgramPhasePromise = body => {
  return getApiClient()
    .post('program-phases', { body })
    .then(resp => resp.data)
}
